export const feedbackUrl = 'https://gh.io/models-feedback'
export const bookACallUrl = 'https://gh.io/models-playground-feedback'
export const productTermsLink = 'https://www.microsoft.com/licensing/terms/productoffering/MicrosoftAzure/MCA'
export const privacyStatementLink = 'https://www.microsoft.com/licensing/terms/product/PrivacyandSecurityTerms/MCA'
export const modelsTabChangelogLink =
  'https://github.blog/changelog/2025-05-19-github-models-built-into-your-repository-is-in-public-preview/'
